import { SafetyContentRouter } from "../../routers/SafetyContentRouter"
import { SafetyDesktopMapRouter } from "../../routers/SafetyDesktopMapRouter"
import { SidebarRouter } from "../../routers/SidebarRouter"

import * as Styled from "./SafetyDesktopLayout.styled"

export function SafetyDesktopLayout() {

    return (
        <Styled.Wrapper>
            <SidebarRouter />
            <SafetyContentRouter />
            <Styled.Map>
                <SafetyDesktopMapRouter />
            </Styled.Map>
        </Styled.Wrapper>
    )
}